import { useEffect, useState, MouseEvent } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { compareObjects } from '@/lib/Compare';
import { FactoryType } from '@/types';
import { Box, Button } from '@mui/material';
import Loading from '@/component/mui/Backdrop';
import FactorySettingForm from '@/component/factory-setting/FactorySettingForm';
import { updateFactory } from '@/api/asset/factory/update';

export default function FactoryDetail() {
  const {
    state: { rowValue },
  } = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  const [factory, setFactory] = useState<FactoryType>({
    adminAddress: '',
    contractAddr: '',
    network: '137',
    description: '',
    title: '',
  });
  const [oldFactory, setOldFactory] = useState(factory);

  const navigate = useNavigate();

  useEffect(() => {
    setFactory(rowValue);
    setOldFactory(rowValue);

    return () => {};
  }, []);

  const onSubmit = async (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setIsLoading(true);
    await handleContract();
  };
  const handleContract = async () => {
    try {
      const data = compareObjects(factory, oldFactory);
      console.log(data);
      const re = await updateFactory(rowValue.factoryId, data as FactoryType);
      if (re.status !== 200) {
        return;
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
    toast.success('성공');
    navigate('/factory-list');
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          overflow: 'auto',
          flex: 1,
          flexDirection: 'column',
          gap: { xs: '16px', sm: '0px' },
        }}
      >
        <FactorySettingForm factory={factory} setFactory={setFactory} title="Factory-Detail" type="detail" />
        <Button variant="contained" onClick={onSubmit}>
          Update
        </Button>
      </Box>
      <Loading isLoading={isLoading} />
    </>
  );
}
